module.exports = __webpack_public_path__ + "img/index_back1@2x.2326ff5b.png";